import React from 'react';

import { makeStyles } from '@gogame/components';

const useStyles = makeStyles(() => ({
  video: {
    display: 'block',
    width: ({ width }) => width,
    height: ({ height }) => height,
    maxWidth: ({ maxWidth }) => maxWidth,
    maxHeight: ({ maxHeight }) => maxHeight,
  },
}));

export default ({ src, width, height, maxWidth, maxHeight }) => {
  const classes = useStyles({ width, height, maxWidth, maxHeight });

  return (
    <video
      className={classes.video}
      src={src}
      controls
      disablePictureInPicture
      controlsList={'nodownload'}
    />
  );
};
